import { Box, Flex, Icon, IconButton } from "@chakra-ui/react";
import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react/dist/ssr";
import React, { useEffect, useRef, useState } from "react";

const DevsCarousel = ({ children, gap }) => {
    const scrollContainerRef = useRef(null);
    const [cardWidth, setCardWidth] = useState(0);

    useEffect(() => {
        const updateCardWidth = () => {
            if (scrollContainerRef.current) {
                const firstCard = scrollContainerRef.current.firstChild.firstChild;
                if (firstCard) {
                    setCardWidth(firstCard.clientWidth + gap);
                }
            }
        };

        updateCardWidth();

        const observer = new ResizeObserver(updateCardWidth);
        if (scrollContainerRef.current) {
            observer.observe(scrollContainerRef.current);
        }
        return () => observer.disconnect();
    }, [children, gap]);

    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: -cardWidth, behavior: "smooth" });
        }
    };

    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: cardWidth, behavior: "smooth" });
        }
    };

    return (
        <Box
            position="relative"
            width="90vw" // Forzamos el ancho máximo de la pantalla
            overflow="hidden"
        >
            <IconButton
                aria-label="Desplazar izquierda"
                onClick={scrollLeft}
                position="absolute"
                left={{ base: "8px", md: "16px" }}
                top="50%"
                transform="translateY(-50%)"
                zIndex={2}
                rounded="full"
                bg="white"
                boxShadow="md"
                _hover={{ bg: "gray.100" }}
                size="md"
            >
                <Icon color="#000" boxSize={3}>
                    <CaretLeftIcon />
                </Icon>
            </IconButton>

            <Box width="90vw" overflow="hidden">
                <Box
                    ref={scrollContainerRef}
                    overflowX="auto"
                    overflowY="hidden"
                    width="90vw"
                    scrollbar="hidden"
                >
                    <Flex
                        gap={gap}
                        py={4}
                        px={{ base: 2, md: 8 }}
                        width="max-content"
                        minWidth="90vw" //Evita desbordamientos
                        justifyContent={{ base: "center", md: "flex-start" }}
                    >
                        {children}
                    </Flex>
                </Box>
            </Box>

            <IconButton
                aria-label="Desplazar derecha"
                onClick={scrollRight}
                position="absolute"
                right={{ base: "8px", md: "16px" }}
                top="50%"
                transform="translateY(-50%)"
                zIndex={2}
                rounded="full"
                bg="white"
                boxShadow="md"
                _hover={{ bg: "gray.100" }}
                size="md"
            >
                <Icon color="#000" boxSize={3}>
                    <CaretRightIcon />
                </Icon>
            </IconButton>
        </Box>
    );
};

export default DevsCarousel;
